export default __webpack_public_path__ + "static/media/WStore_Spa.7b3a5a73.png";